import React, { useEffect, useState } from 'react';
import { Link, useIdioma } from '../i18n';
import '../styles/AvisoDeCookies.css';

const CHAVE = 'sp-cookies';
const REABRIR = 'sp-cookies-reabrir';

const lerEscolha = () => {
  try {
    return localStorage.getItem(CHAVE);
  } catch {
    return 'indisponivel'; // sem localStorage a escolha não se guardaria: o aviso voltaria a cada página
  }
};

/** Para o "Cookies" dos rodapés: mudar de ideia tem de ser tão fácil quanto aceitar. */
export const reabrirAvisoDeCookies = () => window.dispatchEvent(new Event(REABRIR));

/**
 * O pedido de consentimento do Google Analytics. Aceitar grava a escolha e
 * chama `carregarGtm` (public/index.html); antes disso o GTM nem baixa.
 * Recusar depois de ter aceitado apaga os cookies `_ga*` e recarrega, para o
 * GTM sair da página.
 *
 * A primeira pintura é sempre vazia, e a escolha só é lida no efeito: o
 * pré-render não tem localStorage, e o HTML pronto não pode trazer o aviso.
 */
const AvisoDeCookies = () => {
  const { t } = useIdioma();
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    if (!lerEscolha()) setAberto(true);
    const reabrir = () => setAberto(true);
    window.addEventListener(REABRIR, reabrir);
    return () => window.removeEventListener(REABRIR, reabrir);
  }, []);

  const escolher = (escolha) => {
    const antes = lerEscolha();
    try {
      localStorage.setItem(CHAVE, escolha);
    } catch {}
    setAberto(false);
    if (escolha === 'aceitos') return window.carregarGtm();
    if (antes !== 'aceitos') return;
    // Sem isto o gtag regrava `_ga_<ID>` no envio que faz ao sair da página, durante o reload.
    window.gtag('consent', 'update', { analytics_storage: 'denied' });
    document.cookie
      .split('; ')
      .map((c) => c.split('=')[0])
      .filter((nome) => nome.startsWith('_ga'))
      .forEach((nome) => {
        // O GA grava no domínio de topo (`.silentpuma.com`); no localhost, sem domínio.
        document.cookie = `${nome}=; Max-Age=0; path=/; domain=${window.location.hostname.replace(/^www\./, '')}`;
        document.cookie = `${nome}=; Max-Age=0; path=/`;
      });
    window.location.reload();
  };

  if (!aberto) return null;

  return (
    <section className="aviso-cookies" aria-label={t('cookies.titulo')}>
      <p>
        {t('cookies.texto')}{' '}
        <Link to="/privacy-policy#cookies">{t('cookies.saibaMais')}</Link>
      </p>
      <div className="aviso-cookies-acoes">
        <button type="button" className="sp-btn sp-btn-secondary" onClick={() => escolher('recusados')}>
          {t('cookies.recusar')}
        </button>
        <button type="button" className="sp-btn sp-btn-secondary" onClick={() => escolher('aceitos')}>
          {t('cookies.aceitar')}
        </button>
      </div>
    </section>
  );
};

export default AvisoDeCookies;
